import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import api from "../../../services/api";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";

let cpf = "";
export default function Cadastro(props) {
  const history = props.history;
  const { notification } = useContext(AppContext);
  const [dados, setDados] = useState({
    nome: "",
    cpf: "",
    email: "",
    senha: "",
  });
  const [comboEscolas, setComboEscolas] = useState([]);
  const [comboFuncoes, setComboFuncoes] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarComboEscolas();
    carregarFuncoes();
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas));
  };

  const carregarFuncoes = () => {
    api.get("funcoes/listar").then((res) => {
      setComboFuncoes(res);
    });
  };

  const vincular = (form) => {
    cpf = form.cpf;

    api
      .put("profissionais/inserir", { vinculacao: true, CPF: form.cpf })
      .then((res) => {
        notification("success", "Usuário vinculado com sucesso!");
        history.push("/app/professional");
      })
      .catch((err) => {
        notification("error", "Não foi possível vincular");
      });
  };

  const cadastro = (params) => {
    let dadosParams = {
      nome: params.nome,
      CPF: params.CPF,
      email: params.email,
      senha: params.senha,
      escolaId: params.escolaId,
      funcaoId: params.funcaoId,
    };

    setDados(dadosParams);

    dadosParams.vinculacao = true;

    api
      .put("profissionais/inserir", dadosParams)
      .then((res) => {
        notification("success", "Profissional cadastrado com sucesso!");
        history.push("/app/professional");
      })
      .catch((err) => {
        const { data } = err;

        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "CPF inválido");
          case 3:
            return notification("error", "Email inválido");
          case 4:
            return notification("error", "Senha inválida");
          case 5:
            return notification("error", "Escola inválida");
          case 6:
            return notification("error", "Função inválida");
          case 7:
            return notification("error", "Profissional já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fVinculo = {
    title:
      "Usuário já tem conta na Perto? Informe o CPF do usuário para criar o cadastro de profissional",
    form: {
      cpf: {
        label: "CPF",
        type: "number",
        value: cpf,
      },
    },

    submit: {
      label: "salvar",
      action: vincular,
    },
  };

  const camposfiltros = () => {
    const campos = {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
      },
    };

    campos.CPF = {
      label: "CPF",
      type: "number",
      space: 3,
      value: dados.CPF,
    };

    campos.email = {
      label: "Email",
      type: "text",
      space: 3,
      value: dados.email,
    };

    // if (profId === 0) {
    campos.senha = {
      label: "Senha",
      type: "text",
      value: dados.senha,
    };
    // }

    campos.funcaoId = {
      label: "Função",
      type: "select",
      emptyItem: true,
      space: 6,
      array: {
        data: comboFuncoes,
        value: "id",
        desc: "nome",
      },
      value: dados.funcaoId,
    };

    campos.escolaId = {
      label: "Escola",
      type: "select",
      emptyItem: true,
      space: 6,
      array: {
        data: comboEscolas,
        value: "id",
        desc: "nomeFantasia",
      },
      value: dados.escolaId,
    };

    return campos;
  };

  const fFiltros = {
    title: "Novo profissional",
    form: camposfiltros(),
    submit: {
      label: "Salvar",
      action: cadastro,
    },

    history,
    close: true,
  };

  return (
    <div>
      {/* {!cicloSelecionado ? ( */}
      <>
        <>
          <Form formData={fVinculo} />
        </>
        {carregando ? <CircularProgress /> : <Form formData={fFiltros} />}

        {/* {profId > 0 && (
            <>
              {carregando ? (
                <CircularProgress />
              ) : (
                <>
                  <ActionTable structure={tRegistros} />
                </>
              )}
            </>
          )} */}
      </>
      {/* ) : (
        <Form formData={fCiclos} />
      )} */}
    </div>
  );
}
